module.exports = __webpack_public_path__ + "img/VirtualMachine.a15872b1.svg";